export const GRID_GUTTER = 16;
